import _Object$assign from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/object/assign';
import fecha from 'fecha';
import moment from 'moment';
var defaultConfig = {};
var defaultI18n = 'ID';
var availableMonths = {
  EN: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ID: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
};

var availableShortDays = {
  EN: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  ID: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']
};

var presetRangeLabel = {
  EN: {
    today: 'Today',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    lastSevenSays: 'Last 7 Days',
    lastThirtyDays: 'Last 30 Days'
  },
  ID: {
    today: 'Hari ini',
    thisMonth: 'Bulan ini',
    lastMonth: 'Bulan lalu',
    lastSevenDays: '7 Hari Terakhir',
    lastThirtyDays: '30 Hari Terakhir'
  }
};

var defaultCaptions = {
  title: 'Choose Dates',
  ok_button: 'Apply'
};

var defaultStyle = {
  daysWeeks: 'calendar_weeks',
  days: 'calendar_days',
  daysSelected: 'calendar_days_selected',
  daysInRange: 'calendar_days_in-range',
  firstDate: 'calendar_month_left',
  secondDate: 'calendar_month_right',
  presetRanges: 'calendar_preset-ranges',
  dateDisabled: 'calendar_days--disabled'
};
var countClick = 0;
var defaultPresets = function defaultPresets() {
  var i18n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultI18n;

  return {
    today: function today() {
      var n = new Date();
      var startToday = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0);
      var endToday = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 23, 59);
      return {
        label: presetRangeLabel[i18n].today,
        active: false,
        dateRange: {
          start: startToday,
          end: endToday
        }
      };
    },
    thisMonth: function thisMonth() {
      var n = new Date();
      var startMonth = new Date(n.getFullYear(), n.getMonth(), 2);
      var endMonth = new Date(n.getFullYear(), n.getMonth() + 1, 1);
      return {
        label: presetRangeLabel[i18n].thisMonth,
        active: false,
        dateRange: {
          start: startMonth,
          end: endMonth
        }
      };
    },
    lastMonth: function lastMonth() {
      var n = new Date();
      var startMonth = new Date(n.getFullYear(), n.getMonth() - 1, 2);
      var endMonth = new Date(n.getFullYear(), n.getMonth(), 1);
      return {
        label: presetRangeLabel[i18n].lastMonth,
        active: false,
        dateRange: {
          start: startMonth,
          end: endMonth
        }
      };
    },
    last7days: function last7days() {
      var n = new Date();
      var start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 5);
      var end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
      return {
        label: presetRangeLabel[i18n].lastSevenDays,
        active: false,
        dateRange: {
          start: start,
          end: end
        }
      };
    },
    last30days: function last30days() {
      var n = new Date();
      var start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 29);
      var end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
      return {
        label: presetRangeLabel[i18n].lastThirtyDays,
        active: false,
        dateRange: {
          start: start,
          end: end
        }
      };
    }
  };
};

export default {
  name: 'vue-rangedate-picker',
  props: {
    configs: {
      type: Object,
      default: function _default() {
        return defaultConfig;
      }
    },
    i18n: {
      type: String,
      default: defaultI18n
    },
    months: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    shortDays: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    // options for captions are: title, ok_button
    captions: {
      type: Object,
      default: function _default() {
        return defaultCaptions;
      }
    },
    format: {
      type: String,
      default: 'DD MMM YYYY'
    },
    styles: {
      type: Object,
      default: function _default() {}
    },
    initRange: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    startActiveMonth: {
      type: Number,
      default: new Date().getMonth()
    },
    startActiveYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    presetRanges: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    compact: {
      type: String,
      default: 'false'
    },
    righttoleft: {
      type: String,
      default: 'false'
    }
  },
  data: function data() {
    var dateRange = {};
    // console.log(this.initRange)
    if (this.initRange !== null) {
      var s = moment(this.initRange.start).add(1, 'days');
      var e = moment(this.initRange.end).add(1, 'days');
      dateRange.start = s.toDate();
      dateRange.end = e.toDate();
      var sObject = s.toObject();
      this.startActiveMonth = sObject.months;
      this.startActiveYear = sObject.years;
      this.activeYearEnd = e.toObject().years;
    }
    return {
      dateRange: dateRange,
      numOfDays: 7,
      isFirstChoice: true,
      isOpen: false,
      presetActive: '',
      showMonth: false,
      activeMonthStart: this.startActiveMonth,
      activeYearStart: this.startActiveYear,
      activeYearEnd: this.startActiveYear
    };
  },
  created: function created() {
    if (this.isCompact) {
      this.isOpen = true;
    }
    if (this.activeMonthStart === 11) {
      this.activeYearEnd = this.activeYearStart + 1;
    }
  },

  watch: {
    startNextActiveMonth: function startNextActiveMonth(value) {
      if (value === 0) this.activeYearEnd = this.activeYearStart + 1;
    }
  },
  computed: {
    monthsLocale: function monthsLocale() {
      return this.months || availableMonths[this.i18n];
    },
    shortDaysLocale: function shortDaysLocale() {
      return this.shortDays || availableShortDays[this.i18n];
    },
    s: function s() {
      return _Object$assign({}, defaultStyle, this.style);
    },
    startMonthDay: function startMonthDay() {
      return new Date(this.activeYearStart, this.activeMonthStart, 1).getDay();
    },
    startNextMonthDay: function startNextMonthDay() {
      return new Date(this.activeYearStart, this.startNextActiveMonth, 1).getDay();
    },
    endMonthDate: function endMonthDate() {
      return new Date(this.activeYearEnd, this.startNextActiveMonth, 0).getDate();
    },
    endNextMonthDate: function endNextMonthDate() {
      return new Date(this.activeYearEnd, this.activeMonthStart + 2, 0).getDate();
    },
    startNextActiveMonth: function startNextActiveMonth() {
      return this.activeMonthStart >= 11 ? 0 : this.activeMonthStart + 1;
    },
    finalPresetRanges: function finalPresetRanges() {
      var tmp = {};
      var presets = this.presetRanges || defaultPresets(this.i18n);
      for (var i in presets) {
        var item = presets[i];
        var plainItem = item;
        if (typeof item === 'function') {
          plainItem = item();
        }
        tmp[i] = plainItem;
      }
      return tmp;
    },
    isCompact: function isCompact() {
      return this.compact === 'true';
    },
    isRighttoLeft: function isRighttoLeft() {
      return this.righttoleft === 'true';
    }
  },
  methods: {
    toggleCalendar: function toggleCalendar() {
      if (this.isCompact) {
        this.showMonth = !this.showMonth;
        return;
      }
      this.isOpen = !this.isOpen;
      this.showMonth = !this.showMonth;
    },
    getDateString: function getDateString(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.format;

      if (!date) {
        return null;
      }
      var dateparse = new Date(Date.parse(date));
      // console.log(dateparse)
      return fecha.format(new Date(dateparse.getFullYear(), dateparse.getMonth(), dateparse.getDate() - 1), format);
    },
    getDayIndexInMonth: function getDayIndexInMonth(r, i, startMonthDay) {
      var date = this.numOfDays * (r - 1) + i;
      return date - startMonthDay;
    },
    getDayCell: function getDayCell(r, i, startMonthDay, endMonthDate) {
      var result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return result > 0 && result <= endMonthDate ? result : '&nbsp;';
    },
    getNewDateRange: function getNewDateRange(result, activeMonth, activeYear) {
      var newData = {};
      var key = 'start';
      if (!this.isFirstChoice) {
        key = 'end';
      } else {
        newData['end'] = null;
      }
      var resultDate = new Date(activeYear, activeMonth, result);
      if (!this.isFirstChoice && resultDate < this.dateRange.start) {
        this.isFirstChoice = false;
        return {
          start: resultDate
        };
      }

      // toggle first choice
      this.isFirstChoice = !this.isFirstChoice;
      newData[key] = resultDate;
      return newData;
    },
    selectFirstItem: function selectFirstItem(r, i) {
      var result = this.getDayIndexInMonth(r, i, this.startMonthDay) + 1;
      this.dateRange = _Object$assign({}, this.dateRange, this.getNewDateRange(result, this.activeMonthStart, this.activeYearStart));
      if (this.dateRange.start && this.dateRange.end) {
        this.presetActive = '';
        if (this.isCompact) {
          this.showMonth = false;
        }
      }
      countClick++;
      if (countClick === 2) {
        countClick = 0;
        this.setDateValue();
      }
    },
    selectSecondItem: function selectSecondItem(r, i) {
      var result = this.getDayIndexInMonth(r, i, this.startNextMonthDay) + 1;
      this.dateRange = _Object$assign({}, this.dateRange, this.getNewDateRange(result, this.startNextActiveMonth, this.activeYearEnd));
      if (this.dateRange.start && this.dateRange.end) {
        this.presetActive = '';
      }
      countClick++;
      if (countClick === 2) {
        countClick = 0;
        // alert('click')
        this.setDateValue();
      }
    },
    isDateSelected: function isDateSelected(r, i, key, startMonthDay, endMonthDate) {
      var result = this.getDayIndexInMonth(r, i, startMonthDay) + 1;
      if (result < 2 || result > endMonthDate + 1) return false;

      var currDate = null;
      if (key === 'first') {
        currDate = new Date(this.activeYearStart, this.activeMonthStart, result);
        // console.log(currDate)
        // console.log(this.dateRange.start)
        // console.log(this.dateRange.end)
      } else {
        currDate = new Date(this.activeYearEnd, this.startNextActiveMonth, result);
      }
      return this.dateRange.start && this.dateRange.start.getTime() === currDate.getTime() || this.dateRange.end && this.dateRange.end.getTime() === currDate.getTime();
    },
    isDateInRange: function isDateInRange(r, i, key, startMonthDay, endMonthDate) {
      var result = this.getDayIndexInMonth(r, i, startMonthDay) + 1;
      if (result < 2 || result > endMonthDate + 1) return false;

      var currDate = null;
      if (key === 'first') {
        currDate = new Date(this.activeYearStart, this.activeMonthStart, result);
      } else {
        currDate = new Date(this.activeYearEnd, this.startNextActiveMonth, result);
      }
      return this.dateRange.start && this.dateRange.start.getTime() < currDate.getTime() && this.dateRange.end && this.dateRange.end.getTime() > currDate.getTime();
    },
    isDateDisabled: function isDateDisabled(r, i, startMonthDay, endMonthDate) {
      var result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return !(result > 0 && result <= endMonthDate);
    },
    goPrevMonth: function goPrevMonth() {
      var prevMonth = new Date(this.activeYearStart, this.activeMonthStart, 0);
      this.activeMonthStart = prevMonth.getMonth();
      this.activeYearStart = prevMonth.getFullYear();
      this.activeYearEnd = prevMonth.getFullYear();
    },
    goNextMonth: function goNextMonth() {
      var nextMonth = new Date(this.activeYearEnd, this.startNextActiveMonth, 1);
      this.activeMonthStart = nextMonth.getMonth();
      this.activeYearStart = nextMonth.getFullYear();
      this.activeYearEnd = nextMonth.getFullYear();
    },
    updatePreset: function updatePreset(item) {
      this.presetActive = item.label;
      this.dateRange = item.dateRange;
      // update start active month
      this.activeMonthStart = this.dateRange.start.getMonth();
      this.activeYearStart = this.dateRange.start.getFullYear();
      this.activeYearEnd = this.dateRange.end.getFullYear();
    },

    setDateValue: function setDateValue() {
      this.$emit('selected', this.dateRange);
      // console.log(this.dateRange)
      // alert(this.dateRange)
      if (!this.isCompact) {
        this.toggleCalendar();
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./components/range/js/rangedate-picker.js
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./components/range/js/rangedate-picker.js
// module chunks = 18 19 20 21 22 23 24 25 26 27 28 29